module.exports = __webpack_public_path__ + "img/icon_bi.0e372f76.png";